export default function TypeaheadDropdownRequired() {
    return {
        restrict: 'A',
        priority: 1,
        require: ['ngModel', '^ktTypeaheadDropdown'],
        link: function($scope, $elem, $attrs, [ngModelCtrl, ktTypeaheadDropdown]) {
            const REQUIRED_DEFAULT = true;
            const required = angular.isDefined(ktTypeaheadDropdown.required)
                ? ktTypeaheadDropdown.required : REQUIRED_DEFAULT;
            if (!required) {
                return;
            }

            $scope.$watch(getModelValue, validate, true);

            function validate(value) {
                const isValid = value && value.value;
                ngModelCtrl.$setValidity('typeaheadRequired', !!isValid);
            }

            function getModelValue() {
                return $scope.$eval($attrs.ngModel);
            }
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/common/typeahead-dropdown/typeahead-dropdown-require.js